import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrimFormValuesService } from 'src/app/common/trimmingForm';
import { Utils } from 'src/app/common/utils';
import { DashCred } from 'src/app/models/dash';
import { VproService } from 'src/app/service/vpro/vpro.service';
import Swal from 'sweetalert2';
import { sortBy } from 'underscore';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-view-consultation-appointment',
  templateUrl: './view-consultation-appointment.component.html',
  styleUrls: ['./view-consultation-appointment.component.css']
})
export class ViewConsultationAppointmentComponent implements OnInit {

  appointments: any;
  //Pagination Parameters
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  findAppointmentForm: UntypedFormGroup;
  appointmentType = Utils.APPOINTMENT_TYPE;
  noAppointments: boolean = false;
  filterActive: boolean = false;
  dateFormat = Utils.DATE_FORMAT;
  activeBtn: string;

  constructor(private service: VproService, private spinner: NgxSpinnerService, private _formBuilder: UntypedFormBuilder, private router: Router, private trimFormValuesService: TrimFormValuesService,) { }

  ngOnInit() {
    this.findAppointmentForm = this._formBuilder.group({
      patName: [''],
      apDate: [null]
    });
    this.getAppointments();
  }

  getAppointments(type: string = '', pg: number = 1) {
    let val = this.findAppointmentForm.value;






    let data = {
      org_code: localStorage.getItem('orgcode')
    }
    this.activeBtn = type;
    this.page = pg;
    this.filterActive = type ? true : false;

    if (type === 'INPERSON') {
      data['type'] = this.appointmentType.IN_PERSON;
    }
    if (type === 'ONLINE') {
      data['type'] = 'online';
    }
    if (val.apDate) {
      data['apdate'] = val.apDate.year + "-" + val.apDate.month + "-" + val.apDate.day
    }
    if (val.patName) {
      data['patient_name'] = val.patName
    }
    console.log("Search  1", data);
    this.trimFormValuesService.trimValues(data);
    console.log("Search VALUES 2", data);
    this.spinner.show();
    this.service.getCheckedInPats(data, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      this.appointments = res['data'];
      console.log("this.appointments", this.appointments);
      this.collectionSize = res['totalCount'];
      if (this.appointments && this.appointments.length) {
        this.noAppointments = false;
      }
      else {
        this.noAppointments = true;
        this.page = 1;
        this.pagesize = Utils.DEFAULT_PAGE_COUNT_SHOW;
      }
      console.log("countcountcount", this.collectionSize);
    }, error => {
      console.log(error)
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    })
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  pageChanged() {
    this.getAppointments(this.activeBtn, this.page);
  }

  gotoPrescriptionPage(apt) {
    if (apt.apttype === this.appointmentType.IN_PERSON) {
      this.router.navigate([`/phydash/${apt.pid}`], { queryParams: { cid: apt.cid } });
    }
    else
      this.router.navigate(['/physician/consultation'], { queryParams: { pid: apt.pid, drid: apt.drid, aid: apt.aid, aptid: apt.aptid } });
  }
}
